import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-56648fea")

_pushScopeId("data-v-56648fea")
const _hoisted_1 = {
  key: 0,
  class: "hotspot-module-container"
}
const _hoisted_2 = {
  key: 0,
  class: "cover-wrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "detail-wrapper-bg"
}
const _hoisted_4 = {
  key: 0,
  class: "detail-wrapper"
}
const _hoisted_5 = { class: "detail-title" }
const _hoisted_6 = {
  key: 1,
  class: "detail-wrapper"
}
const _hoisted_7 = { class: "top-wrapper no-bottom" }
const _hoisted_8 = {
  key: 0,
  class: "slogan-wrapper margin-top-small"
}
const _hoisted_9 = { class: "list-wrapper" }
const _hoisted_10 = { class: "item-left" }
const _hoisted_11 = { class: "item-right" }
const _hoisted_12 = { class: "item-name" }
const _hoisted_13 = {
  key: 0,
  class: "item-origin"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "item-action" }, [
  /*#__PURE__*/_createVNode("span", null, "查看")
], -1)
const _hoisted_15 = {
  key: 2,
  class: "detail-wrapper"
}
const _hoisted_16 = { class: "top-wrapper no-bottom" }
const _hoisted_17 = {
  key: 0,
  class: "slogan-video-wrapper"
}
const _hoisted_18 = {
  key: 1,
  class: "slogan-wrapper"
}
const _hoisted_19 = {
  key: 3,
  class: "detail-wrapper"
}
const _hoisted_20 = { class: "top-wrapper" }
const _hoisted_21 = {
  key: 0,
  class: "slogan-cover-wrapper"
}
const _hoisted_22 = {
  key: 1,
  class: "slogan-wrapper"
}
const _hoisted_23 = {
  key: 0,
  class: "person-wrapper"
}
const _hoisted_24 = { class: "person-title" }
const _hoisted_25 = { class: "person-avatar" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "person-desc" }, [
  /*#__PURE__*/_createVNode("span", null, "专家详情"),
  /*#__PURE__*/_createVNode("span", null, "/ DETAILS")
], -1)
const _hoisted_28 = { class: "person-intro" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "intro-left-bottom" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "intro-right-top" }, null, -1)
const _hoisted_31 = { class: "intro-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImgContainer = _resolveComponent("ImgContainer")
  const _component_HotspotContentList = _resolveComponent("HotspotContentList")
  const _component_Back = _resolveComponent("Back")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_ctx.modules)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (!_ctx.showDetail)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("img", {
                class: "bg-image",
                src: _ctx.modules.background[0]
              }, null, 8, ["src"]),
              _createVNode("img", {
                class: "center-image",
                src: _ctx.modules.background[1]
              }, null, 8, ["src"]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list, (i, k) => {
                return (_openBlock(), _createBlock("div", {
                  class: `cover-image image-${k}`,
                  key: k,
                  onClick: _withModifiers(($event: any) => (_ctx.click(k)), ["stop","prevent"])
                }, [
                  _createVNode("img", {
                    src: i.cover
                  }, null, 8, ["src"]),
                  _createVNode("p", null, _toDisplayString(i.title), 1)
                ], 10, ["onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail && _ctx.modules.list[_ctx.currentIndex].detail)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (
          !_ctx.showMoreDetail &&
          (_ctx.currentIndex === 0 || _ctx.currentIndex === 1 || _ctx.currentIndex === 4)
        )
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.title), 1)
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.list, (i, k) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "detail-item",
                        key: k
                      }, [
                        _createVNode(_component_ImgContainer, {
                          src: i.img
                        }, null, 8, ["src"]),
                        _createVNode("div", {
                          class: "detail-item-image-desc",
                          onClick: _withModifiers(($event: any) => (_ctx.clickMore(k)), ["stop","prevent"])
                        }, [
                          _createVNode("span", null, _toDisplayString(i.title), 1)
                        ], 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showMoreDetail && _ctx.currentIndex === 2)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.top.title), 1)
                    ]),
                    (_ctx.modules.list[_ctx.currentIndex].detail.top.slogan)
                      ? (_openBlock(), _createBlock("div", _hoisted_8, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.top.slogan, (i, k) => {
                            return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_9, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.list, (i, k) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "list-item",
                          key: k,
                          onClick: _withModifiers(($event: any) => (_ctx.showPerson(i)), ["stop","prevent"])
                        }, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode(_component_ImgContainer, {
                              src: i.img
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", _hoisted_11, [
                            _createVNode("p", _hoisted_12, _toDisplayString(i.name), 1),
                            (i.origin)
                              ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(i.origin), 1))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(i.desc, (m, n) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "item-desc",
                                key: n
                              }, [
                                _createVNode("img", {
                                  src: `${_ctx.rootUrl}/hotspot/final/item_good.png`
                                }, null, 8, ["src"]),
                                _createVNode("p", null, _toDisplayString(m), 1)
                              ]))
                            }), 128))
                          ]),
                          _hoisted_14
                        ], 8, ["onClick"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showMoreDetail && _ctx.currentIndex === 3)
                ? (_openBlock(), _createBlock("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.top.title), 1)
                    ]),
                    (_ctx.modules.list[_ctx.currentIndex].detail.top.video)
                      ? (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode("video", {
                            src: _ctx.modules.list[_ctx.currentIndex].detail.top.video,
                            controls: "controls",
                            preload: "auto",
                            "x5-playsinline": "true",
                            playsinline: "true",
                            "webkit-playsinline": "true",
                            onPlay: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleVideoPlay && _ctx.handleVideoPlay(...args)))
                          }, null, 40, ["src"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.modules.list[_ctx.currentIndex].detail.top.slogan)
                      ? (_openBlock(), _createBlock("div", _hoisted_18, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.top.slogan, (i, k) => {
                            return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_HotspotContentList, {
                      list: _ctx.modules.list[_ctx.currentIndex].detail.list,
                      onAudiobgstop: _ctx.audiobgstop
                    }, null, 8, ["list", "onAudiobgstop"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showMoreDetail)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("span", null, _toDisplayString(_ctx.modules.list[_ctx.currentIndex].detail.list[_ctx.currentMoreIndex].detail.top
              .title), 1)
                    ]),
                    (
            _ctx.modules.list[_ctx.currentIndex].detail.list[_ctx.currentMoreIndex].detail.top
              .cover
          )
                      ? (_openBlock(), _createBlock("div", _hoisted_21, [
                          _createVNode("img", {
                            src: 
              _ctx.modules.list[_ctx.currentIndex].detail.list[_ctx.currentMoreIndex].detail
                .top.cover
            
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true),
                    (
            _ctx.modules.list[_ctx.currentIndex].detail.list[_ctx.currentMoreIndex].detail.top
              .slogan
          )
                      ? (_openBlock(), _createBlock("div", _hoisted_22, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modules.list[_ctx.currentIndex].detail.list[
              _ctx.currentMoreIndex
            ].detail.top.slogan, (i, k) => {
                            return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_HotspotContentList, {
                      list: 
            _ctx.modules.list[_ctx.currentIndex].detail.list[_ctx.currentMoreIndex].detail.list
          ,
                      onAudiobgstop: _ctx.audiobgstop
                    }, null, 8, ["list", "onAudiobgstop"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showDetail)
          ? (_openBlock(), _createBlock(_component_Back, {
              key: 2,
              onAction: _ctx.goBack
            }, null, 8, ["onAction"]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_popup, {
          round: "",
          style: `position: fixed;`,
          show: _ctx.popShow,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.popShow = $event)),
          onClosed: _ctx.popClose,
          teleport: "#app"
        }, {
          default: _withId(() => [
            (_ctx.popData)
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _createVNode("img", {
                        src: _ctx.popData.avatar
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("div", {
                      class: `person-name  ${_ctx.popData.origin ? '' : 'only'}`
                    }, [
                      _createVNode("span", null, _toDisplayString(_ctx.popData.name), 1),
                      (_ctx.popData.origin)
                        ? (_openBlock(), _createBlock("span", _hoisted_26, _toDisplayString(_ctx.popData.origin), 1))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _hoisted_27,
                  _createVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _hoisted_30,
                    _createVNode("div", _hoisted_31, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.popData.intro, (i, k) => {
                        return (_openBlock(), _createBlock("p", { key: k }, _toDisplayString(i), 1))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show", "onClosed"])
      ]))
    : _createCommentVNode("", true)
})